import {
  format,
  parseISO,
} from 'date-fns';

import { uiMutationTypes } from './mutation-types';

export const actions = {
  addDateRange({ commit }, dateRange) {
    const dateRangeFormatted = {
      start: format(parseISO(dateRange.start), 'yyyy-LL-dd'),
      end: format(parseISO(dateRange.end), 'yyyy-LL-dd'),
    };

    commit(uiMutationTypes.ADD_RANGE_DATE, dateRangeFormatted);
  },
  addChannel({ commit }, channel) {
    commit(uiMutationTypes.ADD_CHANNEL, channel);
  },
  addTabName({ commit }, tabName) {
    commit(uiMutationTypes.ADD_TAB_NAME, tabName);
  },
  addGroupList({ commit }, groupList) {
    commit(uiMutationTypes.ADD_GROUP_LIST, groupList);
  },
};
